<template>
  <ul class="course-categories">
    <b-collapse animation="" :open="true" aria-id="right-categories-list">
      <li @click="open" class="list_header categories active" slot="trigger" aria-controls="right-categories-list">
        <span class="left"> <i class="icon-button-arrow"></i>Доступные курсы </span>
      </li>
      <b-collapse
        animation=""
        v-for="(course, j) in CoursesList.filter((el) => el.status === 1)"
        :key="j"
        :open="false"
        :aria-id="'course-item-' + j"
      >
        <li @click="open" class="list_header course" slot="trigger" :aria-controls="'course-item-' + j">
          <span class="left"> <i class="mdi mdi-plus"></i><i class="mdi mdi-minus"></i>{{ course.name }} </span>
        </li>
        <li
          v-for="(stage, k) in course.stages"
          :key="k"
          class="list_item"
          @click="startStage(stage, course, k)"
          :class="calcClass(k, course.stages)"
        >
          <span class="left">
            <i v-if="stage.type === 1" class="icon-play"></i>
            <i v-if="stage.type === 2" class="icon-pie-chart"></i>
            <i v-if="stage.type === 3" class="icon-test"></i>
            <span class="text">{{ stage.name }}</span>
          </span>
        </li>
      </b-collapse>
    </b-collapse>
  </ul>
</template>

<script>
import { toastDanger } from '@/lib/toastCfg'

export default {
  props: {
    CoursesList: {
      default: () => [],
      type: Array
    }
  },
  methods: {
    calcClass(index, array) {
      if (index === 0 || array[index - 1].passed) return ''
      return 'list_item--disabled'
    },
    startStage(stage, course, index) {
      if (course.stages[index - 1] && !course.stages[index - 1].passed) {
        this.$buefy.toast.open(toastDanger('Пройдите предыдущие уроки курса'))
        return
      }
      if (this.$moment(course.date_start).isAfter(this.$moment(new Date()))) {
        this.$buefy.toast.open(toastDanger('Дождитесь даты начала прохождения курса'))
        return
      }
      this.$router.push('/my-courses/' + stage.id + '?courseId=' + course.id)
    },
    open(e) {
      if (e.currentTarget.classList.contains('active')) {
        e.currentTarget.classList.remove('active')
      } else {
        e.currentTarget.classList.add('active')
      }
    }
  }
}
</script>
